<div class="wrap">
  <header>
    <h3 class="heading">{{ options.title }}</h3>
    <button class="close-button" (click)="closeModal()"><span class="icon-close"></span></button>
  </header>
  <label class="dropzone" appDragAndDrop (fileDropped)="onFileDropped($event)">
    <input type="file" #fileDropRef [multiple]="options.multiple" (change)="fileBrowseHandler($event.target.files)">
    <h3 class="drag-drop-body">{{ 'common.uploadModal.dragAndDropBoxBody' | translate }}</h3>
  </label>
  <div class="info">
    <span class="restriction" *ngIf="options.restrictionMessage">
      {{options.restrictionMessage}}
    </span>
    <ng-container *ngIf="!options.autoComplete">
      <div *ngFor="let file of files; ; let i = index" class="tag">
        <span>{{ file.name }}</span>
        <button class="remove-file" (click)="removeFile(i)"><span class="icon-close"></span></button>
      </div>
    </ng-container>
  </div>
  <div class="camera-button">
    <button class="bciti-button bciti-button--blue" *ngIf="!displayCamera" (click)="toggleDisplayCamera()">{{ 'common.uploadModal.activateCameraButton' | translate }}</button>
  </div>
  <div class="camera-picture" *ngIf="displayCamera">
    <div class="camera-button">
      <button class="bciti-button bciti-button--blue" (click)="triggerSnapshot()">{{ 'common.uploadModal.captureCameraButton' | translate }}</button>
    </div>
    <div class="camera-preview">
      <webcam [imageQuality]="cameraImageQuality"
        [imageType]="cameraImageCaptureType"
        [allowCameraSwitch]="true"
        [trigger]="cameraCaptureImageObservable"
        (imageCapture)="handleImageCapture($event)">
      </webcam>
    </div>
  </div>
  <footer *ngIf="!options.autoComplete">
    <button 
      class="bciti-button bciti-button--blue" 
      [disabled]="!this.files.length"
      (click)="complete()">
      {{ 'common.uploadModal.downloadButton' | translate }}
    </button>
  </footer>
</div>
